import React from 'react';

interface ProjectFolderIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const ProjectFolderIcon: React.FC<ProjectFolderIconProps> = ({
  color = '#2372b9',
  height = 24,
  width = 24,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 640 640"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    <path
      fill={color}
      d="M128 512L512 512C547.3 512 576 483.3 576 448L576 208C576 172.7 547.3 144 512
         144L362.7 144C355.8 144 349 141.8 343.5 137.6L305.1 108.8C294 100.5 280.5 96 266.7
         96L128 96C92.7 96 64 124.7 64 160L64 448C64 483.3 92.7 512 128 512z"
    />
  </svg>
);

export default ProjectFolderIcon;